// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeDeductionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/employee_deductions
 * Returns array of employee deduction records
 */
import type { Payroll_DeductionRow } from './Payroll_DeductionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_EmployeeDeductionsResponseDados {
deductions: Payroll_DeductionRow[]
}

export type Payroll_EmployeeDeductionsResponse = ApiResponse<Payroll_EmployeeDeductionsResponseDados>;

registerResponseContract('Payroll_EmployeeDeductionsResponse', {
  deductions: {
    type: 'array',
    required: true,
    items: {
      id:               { type: 'number',  required: true },
      employee_id:      { type: 'string',  required: true },
      franchise_id:     { type: 'number',  required: true },
      title:            { type: 'string',  required: true },
      description:      { type: 'string',  required: false },
      amount:           { type: 'string',  required: true },
      status:           { type: 'number',  required: true },
      amount_paid:      { type: 'string',  required: true },
      created_at:       { type: 'string',  required: true },
      created_by:       { type: 'string',  required: true },
      updated_at:       { type: 'string',  required: false },
      amount_remaining: { type: 'number',  required: false },
      employee_name:    { type: 'string',  required: false },
      status_label:     { type: 'string',  required: false },
      items:            { type: 'array',   required: false },
    },
  },
})
